import Vue from 'vue'
import Router from 'vue-router'

const Login = () =>
    import ('./components/Login.vue')

const Home = () =>
    import ('./components/Home.vue')
const Welcome = () =>
    import ('./components/Welcome.vue')
const Users = () =>
    import ('./components/user/Users.vue')

const UserStock = () =>
    import ('./components/user/UserStock.vue')

const Recharge = () =>
    import ('./components/user/Recharge.vue')
const PtRechargeAccount = () =>
    import ('./components/user/ptRechargeAccount.vue')
const Rights = () =>
    import ( /* webpackChunkName: "Users_Rights_Roles" */ './components/power/Rights.vue')
const Cate = () =>
    import ('./components/goods/Cate.vue')
const AddActivity = () =>
    import ('./components/goods/AddActivity.vue')
const UserActivityManaged = () =>
    import ('./components/goods/UserActivityManaged.vue')
const ActivityList = () =>
    import ( /* webpackChunkName: "Cate_Params" */ './components/goods/ActivityList.vue')
    // import Params from './components/goods/Params.vue'
const Params = () =>
    import ( /* webpackChunkName: "Cate_Params" */ './components/goods/Params.vue')

// import GoodsList from './components/goods/List.vue'
const GoodsList = () =>
    import ('./components/goods/List.vue')
const SetGoodInvoice = () =>
    import ('./components/goods/SetGoodInvoice.vue')

const DwGoodEndTime = () =>
    import ('./components/goods/DwGoodEndTime.vue')

const Add = () =>
    import ( /* webpackChunkName: "GoodsList_Add" */ './components/goods/Add.vue')

// import UsersShouxin from './components/financial/usersShouxin.vue'
const UsersShouxin = () =>
    import ('./components/financial/usersShouxin.vue')
const Order = () =>
    import ('./components/order/Order.vue')
const HistoryOrder = () =>
    import ('./components/dataBase/historyOrder.vue')
const DealHistory = () =>
    import ('./components/dataBase/dealHistory.vue')

const DwGoodsList = () =>
    import ('./components/order/DwGoodsList.vue')
const jxsOrder = () =>
    import ('./components/jxs/Order.vue')
const jxsOrderDetail = () =>
    import ('./components/jxs/Detail.vue')

const DwOrder = () =>
    import ('./components/order/DwOrder.vue')
const OrderDetail = () =>
    import ('./components/order/Detail.vue')
const DwOrderDetail = () =>
    import ('./components/order/DwDetail.vue')

const consumeList = () =>
    import ('./components/financial/consumeList.vue')

const consumeWalletList = () =>
    import ('./components/financial/consumeWalletList.vue')

const fapiaoList = () =>
    import ('./components/financial/fapiaoList.vue')
const wuliuList = () =>
    import ('./components/financial/wuliuList.vue')

const Report = () =>
    import ('./components/report/Report.vue')
const NoticeList = () =>
    import ('./components/notice/NoticeList.vue')
const LunboList = () =>
    import ('./components/lunbo/Lunbo.vue')
const NoticeAdd = () =>
    import ('./components/notice/Add.vue')
const FeedbackList = () =>
    import ('./components/notice/FeedbackList.vue')

const KucunList = () =>
    import ('./components/kucun/List.vue')
const printPage = () =>
    import ('./components/kucun/printPage.vue')
const EditHistory = () =>
    import ('./components/kucun/editHistory.vue')


const KucunOrder = () =>
    import ('./components/kucun/Order.vue')
const ManagedList = () =>
    import ('./components/admin/ManagedList.vue')
const account_checking = () =>
    import ('./components/financial/account_checking.vue')
const salemanList = () =>
    import ('./components/admin/salemanList.vue')
const Roles = () =>
    import ('./components/admin/Roles.vue')
const MyConsumeList = () =>
    import ('./components/jxs/myConsumeList.vue')

Vue.use(Router)

const router = new Router({
    routes: [
        { path: '/', redirect: '/login' },
        { path: '/login', component: Login },
        { path: '/printPage', component: printPage },
        {
            path: '/home',
            component: Home,
            redirect: '/welcome',
            children: [
                { path: '/welcome', component: Welcome },
                { path: '/users', component: Users },
                { path: '/UsersStock', component: UserStock }, //经销商库存列表
                { path: '/recharge', component: Recharge },
                { path: '/ptRechargeAccount', component: PtRechargeAccount },
                { path: '/rights', component: Rights },
                { path: '/roles', component: Roles },
                { path: '/categories', component: Cate },
                { path: '/activityList', component: ActivityList },
                { path: '/userActivityManaged', component: UserActivityManaged },
                { path: '/params', component: Params },
                { path: '/goods', component: GoodsList },
                { path: '/goods/add', component: Add },
                { path: '/goods/addActivity', component: AddActivity },
                { path: '/goods/dwGoodEndTime', component: DwGoodEndTime },
                { path: '/setGoodInvoice', component: SetGoodInvoice },

                { path: '/dealHistory', component: DealHistory },
                { path: '/historyOrder', component: HistoryOrder },

                { path: '/orders', component: Order },
                { path: '/jxsOrder', component: jxsOrder },
                { path: '/jxsOrderDetail', component: jxsOrderDetail },

                { path: '/consumeList', component: consumeList },
                { path: '/salemanList', component: salemanList },
                { path: '/consumeWalletList', component: consumeWalletList },
                { path: '/fapiaoList', component: fapiaoList },
                { path: '/wuliuList', component: wuliuList },

                { path: '/dwOrders', component: DwOrder },
                { path: '/dwGoodsList', component: DwGoodsList },
                { path: '/orders/detail', component: OrderDetail },
                { path: '/orders/dwdetail', component: DwOrderDetail },
                { path: '/reports', component: Report },
                { path: '/noticeList', component: NoticeList },
                { path: '/lunboList', component: LunboList },
                { path: '/feedbackList', component: FeedbackList },
                { path: '/noticeList/add', component: NoticeAdd },
                //库存
                { path: '/kucunList', component: KucunList },

                { path: '/editHistory', component: EditHistory },
                { path: '/kucunOrder', component: KucunOrder },
                { path: '/managedList', component: ManagedList },
                { path: '/account_checking', component: account_checking },
                { path: '/myConsumeList', component: MyConsumeList },
                { path: '/usersShouxin', component: UsersShouxin },
            ]
        }
    ]
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // to 将要访问的路径
    // from 代表从哪个路径跳转而来
    // next 是一个函数，表示放行
    //     next()  放行    next('/login')  强制跳转
    // const tokenStr = localStorage.getItem('token')
    // console.log(tokenStr);

    if (to.path === '/login') return next()
    if (to.path === '/printPage') return next()
        // 获取token
    const tokenStr = window.sessionStorage.getItem('token')
    console.log(tokenStr);
    if (!tokenStr) return next('/login')
    next()
})

export default router